<template>

  <div class="bk-color" style="padding-bottom: 12px;">

  <v-row class="icoev-header-row fixNotchMarginTop fixNotchPaddingBottom">
			<v-col cols="6" style="padding: 0; padding-right: 10px;">
        <v-img src="../../../assets/logo-icoev.svg" class="logo-header-image" style="margin: 6px 0;"/>
        <!-- <v-img src="../../../assets/logo-icoev-header.png" width="270" style="margin: 5px;"/> -->
      </v-col>
			<v-col cols="6" style="margin: 5px 0 0 -5px; padding: 0; height: 60px;">	
				<v-list style ="padding: 0;">	
					<v-list-item style="padding: 0;">						
						<v-list-item-content style="color: #065535; text-align: right;">
							<v-list-item-title><strong style="font-size: 13px;">{{ userChanged ? userChanged.apellidos + ", " + userChanged.nombre : '??????, ??????' }}</strong></v-list-item-title>
							<v-list-item-subtitle style="color: #065535; font-size: 13px;">{{ userChanged ? userChanged.numcol : '00000000' }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-col>
    </v-row>

    <div class="icoev-main-content-wrapper fixNotchMarginTop fixNotchPaddingBottom" >

		<!-- Newsletters -->
		<h4 class="primary--text pa-2">		
			<v-icon color="primary" style="top: -2px;">mdi-email</v-icon>	
			Newsletters
		</h4>
		<v-card
			outlined
			class="mx-auto"
			max-width="95%"
		>
			<v-card-text style="padding: 0;">
				<v-list v-if="!isLoading" style="padding: 0;">                
					<div v-for="newsletter in newsletters" :key="newsletter.id">
						<NewsletterItem :data="newsletter" @open-external-content="openUrl(arguments)"/>
						<v-divider v-if="newsletter.id != newsletters[newsletters.length-1].id"/>
					</div>
        </v-list>
			</v-card-text>
			<v-divider/>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="$router.push({ name: 'newsletter' })">
					Ver más
				</v-btn>
			</v-card-actions>
		</v-card>

    <!-- Alertas sanitarias -->
    <h4 class="primary--text pa-2">
			<v-icon color="primary" style="top: -2px;">mdi-alert</v-icon>
			Alertas sanitarias
		</h4>
    <v-card
      outlined
      class="mx-auto"
      max-width="95%">
			<v-card-text style="padding: 0;">
				<v-list v-if="!isLoading" style="padding: 0;">                
					<div v-for="alert in alerts" :key="alert.id">
						<AlertItem :data="alert" @open-external-content="openUrl(arguments)"/>
						<v-divider v-if="alert.id != alerts[alerts.length-1].id"/>
					</div>
        </v-list>
			</v-card-text>
			<v-divider/>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" align="right" @click.stop="$emit('open-alerts-dialog', false)">
					Ver más
				</v-btn>
			</v-card-actions>
		</v-card>
  
		<!-- Bolsa de trabajo -->
		<h4 class="primary--text pa-2">
			<v-icon color="primary" style="top: -2px;">mdi-briefcase</v-icon>
			Bolsa de trabajo
		</h4>
		<v-card
			outlined
			class="mx-auto"
			max-width="95%"
		>
			<v-card-text style="padding: 0;">
				<v-list v-if="!isLoading" style="padding: 0;">                
					<div v-for="classified in classifieds" :key="classified.id">
						<ClassifiedItem :data="classified"/>
						<v-divider v-if="classified.id != classifieds[classifieds.length-1].id"/>
					</div>
        </v-list>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="$router.push({ name: 'bolsa-trabajo' })">
					Ver más
				</v-btn>
			</v-card-actions>
		</v-card>
    </div>
	</div>

</template>

<script>
import api from '../../../api/icoev';
import BaseModule from "../../common/BaseModule";
import AlertItem from "../../common/AlertItem";
import ClassifiedItem from "../../common/ClassifiedItem";
import NewsletterItem from "../../common/NewsletterItem";

export default {
	name: 'HomeMain',
	mixins: [ BaseModule ],
	components: {
		AlertItem, 
		ClassifiedItem, 
		NewsletterItem
	},
	data() {
		return {
			isLoading: false,
			alerts: [],
			classifieds: [],
			newsletters: [],
			isDirty: true,
			lastUpdate: null,
		}
	},
  mounted() {
		this.$nextTick(() => {
			window.$vue.$on('ne_awake', this.processAwake);
    });
  },
	methods: {
		processAwake: function(seconds) {
			this.$log.debug("HomeMain - processAwake: " + seconds + " secs");
			if (seconds > this.MAX_UPDATE_DELAY_IN_SECONDS) {
				//this.$log.debug("HomeMain - processAwake: paused > 10 secs -> dirty = true");
				this.isDirty = true;
			}
		},
		listarItems: function() {
			this.$log.debug("HomeMain - listarItems()");

			this.updateLatest();
		},
		updateLatest: function() {
			api.getHomeLatest(1,
				res => {
					this.alerts = res.alerts;
					this.classifieds = res.classifieds;
					this.newsletters = res.newsletters;

					this.lastUpdate = new Date();
				},
				err=> {
					this.$log.error(err);
          this.$emit('alert-event', { text: 'Error al actualizar la información más reciente', color: 'error', timeout: 3000 });
				}
			);
		},
		openUrl(args) {
			this.$emit('open-external-content', args[0], args[1]);
		}
	},
	computed: {
		userChanged() {
				return this.$store.state.icoev.user;
		}
	},
	watch: {
		userChanged() {
			this.alerts = [];
			this.classifieds = [];
			this.newsletters = [];
			this.isDirty = true;
		},
		// eslint-disable-next-line no-unused-vars
		/*$route (to, from) {
			if (to.name !== 'home') {
				return;
			}
				
			//this.$log.debug("HomeMain - to.params.redirect: " + to.params.redirect);
			if (to.params.redirect) {
				to.params.redirect = false;
				//this.$log.debug("HomeMain - open-alerts-dialog");
				this.$emit('open-alerts-dialog');
				this.isDirty = false;
			}
			if (to.params.refresh) {
				to.params.refresh = false;
				//this.$log.debug("HomeMain - refresh!");
				this.isDirty = true;
			}
			//this.$log.debug("HomeMain - isDirty: " + this.isDirty);
			if (this.isDirty) {
				this.isDirty = false;
				this.$nextTick(() => {
					this.listarItems();
        });
				//this.$log.debug("HomeMain - isDirty: " + this.isDirty);
			}
		},*/
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (to.name !== 'home') {
				return;
			}

			if (vm.needsUpdate(vm.lastUpdate)) {
				vm.isDirty = true;
			}

			//vm.$log.debug("HomeMain - to.params.redirect: " + to.params.redirect);
			if (to.params.redirect) {
				to.params.redirect = false;
				//vm.$log.debug("HomeMain - open-alerts-dialog");
				vm.$emit('open-alerts-dialog', true);
			}
			if (to.params.refresh) {
				to.params.refresh = false;
				//vm.$log.debug("HomeMain - refresh!");
				vm.isDirty = true;
			}
			//vm.$log.debug("HomeMain - isDirty: " + vm.isDirty);
			if (vm.isDirty) {
				vm.isDirty = false;
				vm.$nextTick(() => {
					vm.listarItems();
        });
				//vm.$log.debug("HomeMain - isDirty: " + vm.isDirty);
			}
		})
	},
}
</script>
